module.exports = __webpack_public_path__ + "img/clam.1710c740.png";